import React, { JSX } from 'react';

export interface IFormInputData {
    classes?: string;
    idx: string;
    label: string;
    titleOrAction?: string | React.JSX.Element;
    value: string;
    type: 'edit' | 'locked' | 'warning' | 'empty';
    icon?: JSX.Element;
    // onCommit: (newValue: string) => void;
    onChange?: (newValue: string) => void;
}

const TextInput = (props: IFormInputData) => {
    console.log('TextInput:', props);
    const { classes, icon, idx, label, titleOrAction, value, type, onChange } = props;

    const [text, setText] = React.useState(value);

    // keep draft in sync only when parent changes value externally
    React.useEffect(() => {
        setText(value);
    }, [value]);

    // debounced preview to parent (optional)
    React.useEffect(() => {
        if (!onChange) return;
        const t = setTimeout(() => onChange(text), 150);
        return () => clearTimeout(t);
    }, [text, onChange]);

    return (
        <div className={`self-stretch flex flex-col justify-center items-start gap-2 text-text-dark ${classes}`}>
            {/* <div className="self-stretch justify-start text-text-dark text-sm font-normal font-['Inter'] leading-tight">{label}</div> */}
            <div className="sm:inline-flex sm:items-center space-y-2 sm:space-y-0 sm:space-x-3 w-full">
                <div className="w-[50%] inline-flex self-stretch justify-start text-text-dark text-sm font-normal font-['Inter'] leading-tight">{label}</div>
                {titleOrAction && <div className="w-[50%] inline-flex self-stretch justify-end text-text-dark text-sm font-normal font-['Inter'] leading-tight">{titleOrAction}</div>}
            </div>
            <div className={`relative self-stretch flex items-center border outline-1 border-border-default hover:border-blue-400 rounded-lg bg-bg-input-${type} transition-colors`}>
                <input
                    id={`formInput-${label.replaceAll(' ', '').trim()}`}
                    type="text"
                    disabled={!['edit', 'empty'].includes(type)}
                    className={`py-1.5 sm:py-2 px-4 w-full outline-0 inline-flex justify-start items-center gap-2.5 bg-transparent`}
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    onBlur={() => {
                        if (!onChange) return;
                        onChange(text);
                    }}
                    onKeyDown={(e) => {
                        if (!onChange) return;
                        if (e.key === "Enter") onChange(text);
                    }}
                />
                {icon && <div className="self-stretch flex justify-end items-center me-4">
                    <div className="relative">
                        {icon}
                    </div>
                </div>}
            </div>
        </div>
    );
};

export default TextInput;